import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ITextWithImageOutsideProps } from '../components/text-with-image-outside/text-with-image-outside';
import { TextModel } from './text-model';
import { ITextProps } from '../components/text/text';

export class TextWithImageOutsideModel extends ContentItem {
  get header(): ITextProps[] {
    const items = get(this._config, 'elements.header.value', []);
    const modeledTexts = items.map((article: IText) =>
      TextModel.create(article as IText)
    );
    return modeledTexts;
  }

  get description(): string {
    return get(this._config, 'elements.description_value.value', '');
  }

  get id(): string {
    return get(this._config, 'elements.id.value', '');
  }

  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.image.value[0]', {});
  }

  get reversed(): boolean {
    return get(this._config, 'elements.reversed.value[0].codename') === 'true';
  }

  get backgroundColor(): string {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      'primary'
    );
  }

  get imagePostion(): boolean {
    return get(this._config, 'elements.image_position.value[0].codename');
  }

  public static create(
    data: ITextWithImageOutside
  ): ITextWithImageOutsideProps {
    const {
      header,
      description,
      reversed,
      image,
      imagePostion,
      backgroundColor,
      id
    } = new TextWithImageOutsideModel(data);
    return {
      header,
      description,
      reversed,
      image,
      imagePostion,
      backgroundColor,
      id
    };
  }
}
